// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3HAcM","requiredAsterisk":"Info_requiredAsterisk__1lR7J"};